import { ComponentIds, HierarchyUtils, ProductUtils, ValidationResultFail } from '@inter-ikea-core/core';
import { ValidationBase } from '@inter-ikea-core/core-toolbox';
export class StackingHeightRestrictionValidation extends ValidationBase {
    constructor() {
        super(...arguments);
        this.name = 'StackingHeightRestrictionValidation';
        this.id = 'STACKING_HEIGHT_RESTRICTION_VALIDATION';
    }
    validateCurrentState() {
        return null;
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID) &&
            snapActionCandidate.host.hasComponent(ComponentIds.FRAME_COMPONENT_ID) &&
            (HierarchyUtils.parent(snapActionCandidate.host)?.hasComponent(ComponentIds.FRAME_COMPONENT_ID) ||
                HierarchyUtils.children(entity).find(child => child.hasComponent(ComponentIds.FRAME_COMPONENT_ID)))) {
            return new ValidationResultFail('Invalid position for product', ProductUtils.productRefOrEmptyString(entity));
        }
        return null;
    }
}
//# sourceMappingURL=StackingHeightRestrictionValidation.js.map